import type { FunctionComponent } from "react";
import type { PreloadedQuery } from "react-relay";
import { graphql, useFragment, usePreloadedQuery } from "react-relay";

import { useCurrentPageType } from "shared/hooks";
import { useEditionValue } from "shared/lib/edition";

import { query } from "scmp-app/components/header/header-oneline-menu-container";
import type { headerOnelineMenuContainerQuery } from "scmp-app/queries/__generated__/headerOnelineMenuContainerQuery.graphql";
import type { headerOnelineMenuStyleQuery$key } from "scmp-app/queries/__generated__/headerOnelineMenuStyleQuery.graphql";

import { Container, StyledEntityLink, StyledSectionStyleHeaderMenuItem } from "./styles";

export type Props = {
  className?: string;
  reference: PreloadedQuery<headerOnelineMenuContainerQuery>;
};

export const HeaderOnelineMenuStyle: FunctionComponent<Props> = ({ className, reference }) => {
  const queryReference = usePreloadedQuery(query, reference);

  const data = useFragment<headerOnelineMenuStyleQuery$key>(
    graphql`
      fragment headerOnelineMenuStyleQuery on Query {
        styleOnelineMenu: queue(filter: { name: "scmp_pwa_oneline_menu_style" }) {
          items(first: 100) {
            edges {
              node {
                ... on Section {
                  ...entityLink
                  ...sectionStyleHeaderMenuItem
                }
              }
            }
          }
        }
      }
    `,
    queryReference,
  );

  const edition = useEditionValue({ initializeWithValue: true });
  const currentPageType = useCurrentPageType();
  return (
    <Container className={className}>
      {data.styleOnelineMenu?.items?.edges.map((edge, index) => (
        <StyledEntityLink
          key={index}
          query={{
            module: `oneline_menu_section_${edition}`,
            pgtype: currentPageType,
          }}
          reference={edge.node}
        >
          <StyledSectionStyleHeaderMenuItem reference={edge.node} />
        </StyledEntityLink>
      ))}
    </Container>
  );
};

HeaderOnelineMenuStyle.displayName = "HeaderOnelineMenuStyle";
